import { LayoutHOC } from 'base/ui/layout/layout';
import { createProduct } from './product';

export const createProductPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createProduct());
};
